<div class="container-fluid main-app-container">
  <div class="row">
    <div class="col-12 p-0 main-container theme1">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
